import React from 'react'
import { useAppSelector } from '../../../../store/hooks'
import { selectAccountId } from '../../../../store/auth/authSlice'
import { useGetAllMeetingTemplatesQuery } from '../../../../store/ai/meetingTemplate'
import { ReferencePicker } from './ReferencePicker'
import { toOptions } from './referenceOptions'
import type { ZocksReferenceWidgetProps } from './registry'

export const MeetingTemplateWidget: React.FC<ZocksReferenceWidgetProps> = (props) => {
  const accountId = useAppSelector(selectAccountId)
  const { data, isLoading } = useGetAllMeetingTemplatesQuery({ accountId, includeInactive: false, excludeDeprecated: true })
  return <ReferencePicker {...props} options={toOptions(data?.data)} loading={isLoading} />
}
